import { Button, Grid, InputAdornment } from '@mui/material'
import React, { FC, useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { suppliersAPI } from '../../../../api/supplier/suppliersAPI'
import { ChargeException } from '../../../../api/vehicle/taxisAPI.types'
import ChargeExceptionPattern from './ChargeExceptionPattern'

export const getAdornmentProps = (value: string) => {
  if (value === 'Fixed') {
    return {
      startAdornment: <InputAdornment position="start">£</InputAdornment>,
    }
  }
  if (value === 'Percentage') {
    return { endAdornment: <InputAdornment position="end">%</InputAdornment> }
  }
}

interface ChargeExceptionComponentProps {
  namePrefix?: string
}
const ChargeExceptionComponent: FC<ChargeExceptionComponentProps> = (props) => {
  const { namePrefix = 'chargeException' } = props
  const [chargeExceptions, setChargeExceptions] = useState<ChargeException[]>(
    [],
  )
  const [addException, setAddException] = useState(false)
  const formMethods = useFormContext()

  const supplierId = useSelector((state: any) => state.suppliers.supplier.id)
  const chargeExceptionsResponse = useQuery({
    queryKey: ['getChargeExceptions', supplierId],
    queryFn: async () => suppliersAPI.getChargeExceptions(supplierId),
    refetchOnWindowFocus: false,
  })

  const handleSaveException = () => {
    const formValue: ChargeException = formMethods.getValues('chargeException')
    const mappedValue = { ...formValue, value: Number(formValue.value) }
    setChargeExceptions((prev) => [...prev, mappedValue])
    setAddException(false)
    formMethods.unregister('chargeException')
  }

  const getChargeExceptionNameById = (id: number) => {
    const found = chargeExceptionsResponse?.data?.data.value.find(
      (item) => item.id === id,
    )
    return found?.name
  }
  useEffect(() => {
    formMethods.setValue('chargeExceptions', chargeExceptions)
  }, [chargeExceptions])
  return (
    <>
      {chargeExceptions.map((item, index) => {
        return (
          <Grid
            item
            xs={12}
            key={`${item.chargeExceptionId}_${index}`}
            container
            spacing={2}
            alignItems="center"
          >
            <Grid item xs>
              {`${getChargeExceptionNameById(item.chargeExceptionId)}  - ${
                item.chargeTypeName === 'Fixed' ? '£' : ''
              }${item.value} ${
                item.chargeTypeName === 'Percentage' ? '%' : ''
              }`}
            </Grid>
            <Grid item xs="auto">
              <Button
                type="submit"
                variant="outlined"
                onClick={(e) => {
                  e.preventDefault()
                  setChargeExceptions((prev) => [
                    ...prev.filter((value, i) => i !== index),
                  ])
                }}
              >
                Remove
              </Button>
            </Grid>
          </Grid>
        )
      })}
      {addException && (
        <ChargeExceptionPattern
          namePrefix={namePrefix}
          handleOnSave={handleSaveException}
        />
      )}
      {!addException && (
        <Grid item xs={12}>
          <Button
            type="submit"
            variant="outlined"
            onClick={(e) => {
              e.preventDefault()
              setAddException(true)
            }}
          >
            Add exception
          </Button>
        </Grid>
      )}
    </>
  )
}

export default ChargeExceptionComponent
